import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const accordion = (config: InternalThemeConfig): ComponentsOverrides<Theme>["MuiAccordion"] => ({
    root: {
        borderRadius: config.spacing(1),
        "&:before": {
            content: "none",
        },
        padding: 0,
        "&.Mui-expanded": {
            margin: undefined,
        },
    },
    rounded: {
        borderRadius: undefined,
        "&:first-of-type": {
            borderTopLeftRadius: undefined,
            borderTopRightRadius: undefined,
        },
        "&:last-child": {
            borderBottomLeftRadius: undefined,
            borderBottomRightRadius: undefined,
        },
    },
});

export default accordion;
